/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev';
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(value) {
    return true;
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DevToDev': json['DevToDev'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSON(json['DevToDev']),
    };
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DevToDev': FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSON(value['DevToDev']),
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions.js.map